class NumberUtils {

    static formatNumber(n: number): string {
        return (Math.round(n * 10) / 10).toLocaleString('hu-HU', { minimumFractionDigits: 0, maximumFractionDigits: 1 });
    }
}

export default NumberUtils;
